export default __webpack_public_path__ + "static/20-dd6e65043a2305dfa58317f81551d6be.webp";